export const mainSelect = [
    {id:1, name:"Buildings"},
    {id:2, name:"Train"},
    {id:3, name:"Party"},
    {id:4, name:"Upgrade"},
    {id:5, name:"Research"}
]

export const train = [
    {id:1, name :"Huns"},
    {id:2, name :"Egyptian"},
    {id:3, name :"Roman"},
    {id:4, name :"Gallic"},
    {id:5, name :"Teutonic"},
    {id:6, name :"Spartans"},
]

export const buildings = [
    {id:1, name :"Recources"},
    {id:2, name :"Military"},
    {id:3, name :"Infrastructure"}
]
